const NAME_SPACE = 'compassbioinfo-report'

export default {
  set: (key, value) => {
    localStorage.setItem([NAME_SPACE, key].join('_'), value ? JSON.stringify(value) : null)
  },
  get: key => {
    const value = localStorage.getItem([NAME_SPACE, key].join('_'))
    return value ? JSON.parse(value) : null
  },
  remove: key => {
    localStorage.removeItem([NAME_SPACE, key].join('_'))
  }
}